// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/skeleton/style/index.less
// module id = 1818
// module chunks = 1